import BetaChannelService from "./BetaChannelService";
import BetaChannelApiRouteService from "./BetaChannelApiRouteService";

class NakiHandheldBetaChannelService extends BetaChannelService {
    constructor(apiClient) {
        super(apiClient, new BetaChannelApiRouteService("naki-handheld-beta-channels"));
    }
}

export default NakiHandheldBetaChannelService;
